<template>
  <div>
    <h5>Owners</h5>
    <div class="cards">
      <table class="table table-hover">
        <tbody is="transition-group" name="fade">
          <tr v-for="owner in owners" :key="owner.email">
            <td>
              <CopyClick :text="owner.email">
                {{ owner.email }}
              </CopyClick>
            </td>
            <td>
              <button
                class="btn btn-danger btn-sm btn-transparent"
                @click="openRemoveModal(owner)"
              >
                Remove
              </button>
            </td>
          </tr>
        </tbody>
      </table>

      <el-row class="margin-top-10">
        <el-col :span="24">
          <button class="btn btn-primary" @click="$refs.addNewDialog.open()">
            Add owner
          </button>
        </el-col>
      </el-row>

      <OwnerAddNewDialog
        ref="addNewDialog"
        :organization-id="organizationId"
        :current-owner-emails="owners.map((o) => o.email)"
        @added="onAdded"
      />

      <confirm-modal
        ref="confirmRemoveOwner"
        :show-loading="removeInProgress"
        @confirm="remove()"
      >
        <h4 slot="modal-header" class="modal-title text-danger">
          Remove owner
        </h4>
        <div slot="modal-body">
          <p>Are you sure you want to remove this owner?</p>
        </div>
      </confirm-modal>
    </div>
  </div>
</template>

<script>
import { mapState } from 'vuex'
import notifications from 'services/notifications'
import CopyClick from 'components/CopyClick.vue'
import OwnerAddNewDialog from './OwnerAddNewDialog.vue'

export default {
  components: { CopyClick, OwnerAddNewDialog },
  data: () => {
    return {
      email: '',
      ownerToRemove: null,
    }
  },
  computed: {
    ...mapState({
      owners: (state) => state.adminOwnerList.owners,
      fetchInProgress: (state) => state.adminOwnerList.fetchInProgress,
      saveInProgress: (state) => state.adminOwnerList.saveInProgress,
      removeInProgress: (state) => state.adminOwnerList.removeInProgress,
      errors: (state) => state.adminOwnerList.errors,
    }),
    organizationId() {
      const state = this.$store.state
      if (state.user.data.isOrganizer) {
        return state.user.data.organizationId
      } else if (this.$route.name === 'adminOrganizationEdit') {
        return this.$route.params.organizationId
      } else {
        throw new Error(
          ' => Cannot retrieve organizationId for the user or route',
        )
      }
    },
  },
  created() {
    this.fetch()
  },
  methods: {
    async fetch() {
      this.$store.dispatch('adminOwnerList/fetch', {
        orgId: this.organizationId,
      })
    },
    async saveOwner() {
      try {
        await this.$store.dispatch('adminOwnerList/create', {
          email: this.email,
          orgId: this.organizationId,
        })
        await this.$store.dispatch('adminOwnerList/fetch', {
          orgId: this.organizationId,
        })

        notifications.notify({ title: 'Owner added', type: 'success' })
        this.email = ''
      } catch (error) {
        notifications.notify({ title: 'Something went wrong', type: 'danger' })
      }
    },
    openRemoveModal(owner) {
      this.$refs.confirmRemoveOwner.open()
      this.ownerToRemove = owner
    },
    async remove() {
      try {
        await this.$store.dispatch('adminOwnerList/remove', {
          userId: this.ownerToRemove.user_id,
          orgId: this.organizationId,
        })
      } catch (error) {
        notifications.notify({ title: 'Something went wrong', type: 'danger' })
        return
      }
      this.$refs.confirmRemoveOwner.close()
      notifications.notify({ title: 'Owner removed', type: 'success' })
    },
    onAdded({ owner }) {
      this.fetch()
      notifications.notify({ title: 'Owner added', type: 'success' })
    },
  },
}
</script>
